module.exports = __webpack_public_path__ + "media/images/products/category/sm/9-41b6976f6400eeaabe75d6049d5ba95b.jpg";